import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  itemsToSync: 'ItemsToSync',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.itemsToSync],
  endpoints: {
    getItemsToSync: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(item => ({
                type: TAG_TYPES.itemsToSync,
                id: item.id,
              })),
              { type: TAG_TYPES.itemsToSync, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'itemsToSync', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.itemsToSync, id: 'LIST' }],
    },
    syncItems: {
      invalidatesTags: [{ type: TAG_TYPES.itemsToSync, id: 'LIST' }],
    },
    markItemsAsCompleted: {
      invalidatesTags: [{ type: TAG_TYPES.itemsToSync, id: 'LIST' }],
    },
  },
})

export const { useGetItemsToSyncQuery, useSyncItemsMutation, useMarkItemsAsCompletedMutation } = api
